/** Authored scenery reuse for the later world previews. These are real saved
 * meshes and original matte paintings, not completion of the boss signatures.
 * Units are metres; placements remain outside the physical flight corridor. */
const world = (background, file, layout, fog, surface, options = {}) =>
  Object.freeze({
    style: Object.freeze({
      background: `worlds/${background}`,
      fog,
      surface,
      base: fog,
      accent: '#b4c8d7',
      terrain: options.terrain !== false,
    }),
    file,
    layout,
    count: 10,
    gap: 86,
    clip: null,
    ...options,
  });

export const SKY_LATER_WORLD_SCENERY = Object.freeze({
  'hourglass-king': world('08-hourglass-king', '04-orbital', 'orbital', '#75634e', 'prism', {
    clip: 'MirrorTurn',
    gap: 96,
    elevation: 5,
    terrain: false,
  }),
  'scrap-emperor': world('09-scrap-emperor', '06-wreck', 'graveyard', '#25333e', 'moonlit', {
    clip: 'SearchlightSweep',
    gap: 115,
    bank: 0.18,
    terrain: false,
  }),
  vesper: world('10-vesper', '10-vesper-crystal', 'orbital', '#283552', 'prism', {
    gap: 58,
    elevation: 2,
    terrain: false,
  }),
  'twin-executioners': world(
    '11-twin-executioners',
    '11-twin-gantry',
    'rooftops',
    '#344b60',
    'prism',
    {
      count: 4,
      gap: 220,
      spacing: 22,
      clearance: 90,
      setback: 180,
      terrain: false,
    },
  ),
  'abyssal-angler': world('12-abyssal-angler', '03-watchtower', 'rooftops', '#172b3c', 'moonlit', {
    gap: 74,
    elevation: 5,
    terrain: false,
  }),
  'redline-express': world('13-redline-express', '../16-arch', 'rooftops', '#697a82', 'prism', {
    mobile: false,
    gap: 43,
    elevation: 2,
  }),
  'dragon-sovereign': world('14-dragon-sovereign', '04-orbital', 'orbital', '#c5c9cb', 'prism', {
    clip: 'MirrorTurn',
    gap: 74,
  }),
  'mother-of-mines': world('15-mother-of-mines', '../25-rock', 'orbital', '#40352d', 'prism', {
    mobile: false,
    gap: 42,
    elevation: 8,
  }),
  'pale-surgeon': world('16-pale-surgeon', '05-coolant', 'ridges', '#758c96', 'prism', {
    clip: 'Cooling',
    gap: 86,
  }),
  'hollow-moon': world('17-hollow-moon', '../25-rock', 'orbital', '#202b46', 'prism', {
    mobile: false,
    gap: 68,
    elevation: 18,
    terrain: false,
  }),
  'ember-parliament': world(
    '18-ember-parliament',
    '03-watchtower',
    'rooftops',
    '#59332d',
    'moonlit',
    { gap: 60 },
  ),
  'deep-anchor': world('19-deep-anchor', '06-wreck', 'graveyard', '#1e3b4b', 'moonlit', {
    gap: 112,
    bank: 0.6,
    elevation: 12,
    terrain: false,
  }),
  'helios-unbound': world('20-helios-unbound', '04-orbital', 'orbital', '#5b3023', 'prism', {
    clip: 'MirrorTurn',
    gap: 102,
    terrain: false,
  }),
  'last-reflection': world('21-last-reflection', '06-wreck', 'graveyard', '#25313f', 'moonlit', {
    gap: 94,
    bank: 0.32,
  }),
});
